import React from 'react';
import PropTypes from 'prop-types';

/** Referee whistle for match-status UI when API does not send `iconUrl`. */
function KeyMomentWhistleIcon({ className, item }) {
  if (item?.iconUrl) {
    return (
      <img
        className={className}
        src={item.iconUrl}
        alt=""
        loading="lazy"
      />
    );
  }

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        d="M19.5 7.2c-.4-1.1-1.5-1.8-2.7-1.8h-1.2L14.2 4H8.5C7 4 5.8 5.2 5.8 6.7v6.1c0 1.4 1.1 2.6 2.5 2.7v2.5c0 1.2 1 2.2 2.2 2.2h2.2c1.2 0 2.2-1 2.2-2.2v-1.1h1.5c2.5 0 4.5-2 4.5-4.5V9.7c0-1-.4-1.9-1.2-2.5ZM8.2 6.7c0-.2.1-.4.3-.4h4.8l1.1 1.4H8.2V6.7Zm8.3 12.3c0 .1-.1.2-.2.2h-2.2c-.1 0-.2-.1-.2-.2v-1.6h2.6v1.6Zm3.8-6.3c0 1.7-1.4 3-3 3h-9c-.8 0-1.5-.7-1.5-1.5V8.7h10.5c.6 0 1.1.4 1.3 1 .1.3.2.6.2 1v2.7Z"
      />
    </svg>
  );
}

KeyMomentWhistleIcon.propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape({
    iconUrl: PropTypes.string,
    moment: PropTypes.string,
  }),
};

KeyMomentWhistleIcon.defaultProps = {
  className: '',
  item: undefined,
};

export default KeyMomentWhistleIcon;
